import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const TextField = memo(
  ({ name, label, value, required = false, onChange, type = 'text', error, ...props }) => {
    const handleChange = useCallback((e) => {
      onChange(e);
    }, [onChange])

    const componentCls = classNames('flex flex-col font-medium flex-1 relative', {
      'mb-6': required && error?.length
    });

    const errorCls = classNames('absolute -bottom-0 ml-4 text-xs text-red-600 transition duration-300', {
      'opacity-0': !error?.length,
      'opacity-100': error?.length
    });

    return (
      <div className={componentCls}>
        <input
          className="group text-slate-900 px-3 py-3 rounded text-sm outline-none border border-slate-300 focus:border-blue-600 transition-all duration-300"
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          type={type}
          {...props}
          pattern="[0-9]+"
        />
        <label
          htmlFor={name}
          className="transform -translate-y-[50px] bg-white text-sm mx-3 text-slate-400 self-start transition-all duration-300"
        >
          {label}
          {required && <span className="text-red-400"> *</span>}
        </label>
        {required &&
          <span className={errorCls}>{error}</span>
        }
      </div>
    );
  }
);

TextField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.string
}

